import api from "./api";

const getCourseCategories = async (parentId) => await api.get(`courseCategory/${parentId}`)
const getCourseCategory = async (courseCategoryId,page) => await api.get(`courseCategory/${courseCategoryId}/more`, {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})

export default {getCourseCategories,getCourseCategory}
